import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiBox, FiCheckCircle, FiRefreshCw } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

function Returns() {
  useEffect(() => {
    document.title = `Returns | ${siteConfig.displayName}`;
  }, []);

  return (
    <main className="care-page returns-page">
      <nav className="care-tabs" aria-label="Customer care">
        <Link to="/contact">Contact</Link>
        <Link to="/shipping">Shipping</Link>
        <Link className="is-active" to="/returns">Returns</Link>
        <Link to="/shipping#payment-options">Payment options</Link>
      </nav>
      <header className="care-heading">
        <p className="eyebrow">CUSTOMER CARE</p>
        <h1>Returns</h1>
        <p>Changed your mind? Returns are complimentary within 30 days.</p>
      </header>

      <section className="care-highlights">
        <article><FiRefreshCw /><strong>30 days</strong><span>from the delivery date</span></article>
        <article><FiBox /><strong>Free tracked return</strong><span>with the included label</span></article>
        <article><FiCheckCircle /><strong>Refund in 14 days</strong><span>after inspection</span></article>
      </section>

      <div className="care-columns">
        <section>
          <h2>How to return an online order</h2>
          <ol>
            <li>Place unworn items with original tags in secure packaging.</li>
            <li>Attach the prepaid return label supplied with your order.</li>
            <li>Drop the parcel at the carrier location shown on the label and keep the receipt.</li>
          </ol>
          <h2>Return in store</h2>
          <p>
            Eligible US online purchases can also be returned to a participating
            US store with the order confirmation and original payment method.
          </p>
        </section>
        <section>
          <h2>Return conditions</h2>
          <p>
            Items must be unworn, unwashed and undamaged, with all tags and hygiene
            seals intact. Shoes should be tried on a clean surface and returned in
            their original box.
          </p>
          <h2>Refund timing</h2>
          <p>
            Once a return is received and approved, the refund is issued to the
            original payment method within 14 days. Your bank may need additional
            time to post the credit.
          </p>
          <p>Need help? <Link to="/contact">Contact customer care</Link>.</p>
        </section>
      </div>
    </main>
  );
}

export default Returns;
